module.exports = __webpack_public_path__ + "img/_video_off.873c04f3.svg";